export default {
  computed: {
    $typeAheadMedications() {
      return [
        {
          text: "optional",
          value: null,
          imgURL:""
        },
        {
          text: "Metformin",
          value: "metformin",
          imgURL:"/assets/apps/medications/img/metformin.png"
        },
        {
          text: "Metf.500",
          value: "metf500",
          imgURL:""
        },
        {
          text: "Oxybutynin",
          value: "oxybutynin",
          imgURL:"/assets/apps/medications/img/oxybutynin.png"
        },
        {
          text: "Losartain",
          value: "losartain",
          imgURL:"/assets/apps/medications/img/losartain.png"
        },
        {
          text: "Farxiga",
          value: "farxiga",
          imgURL:"/assets/apps/medications/img/farxiga.png"
        },
        {
          text: "Atorvastain",
          value: "atorvastain",
          imgURL:"/assets/apps/medications/img/atorvastain.png"
        },
        {
          text: "Furosemide",
          value: "furosemide",
          imgURL:"/assets/apps/medications/img/furosemide.png"
        },
        {
          text: "Escitalopram",
          value: "escitalopram",
          imgURL:"/assets/apps/medications/img/escitalopram.png"
        },
        {
          text: "Tramadol",
          value: "tramadol",
          imgURL:"/assets/apps/medications/img/tramadol.png"
        },
        {
          text: "Latanoprost",
          value: "latanoprost",
          imgURL:"/assets/apps/medications/img/latanoprost.png"
        },
        {
          text: "Vitamin D3",
          value: "v_d3",
          imgURL:"/assets/apps/medications/img/v_d3.png"
        },

        {
          text: "Arimidex",
          value: "arimidex",
          imgURL:"/assets/apps/medications/img/arimidex.png"
        },
        {
          text: "Fish oil",
          value: "fish_oil",
          imgURL:""
        },
        {
          text: "Calcium",
          value: "Calcium",
          imgURL:""
        },
        {
          text: "Memantine",
          value: "memantine",
          imgURL:""
        },
        {
          text: "Nebivolol",
          value: "Nebivolol",
          imgURL:""
        },
        {
          text: "Anastrozole",
          value: "anastrozole",
          imgURL:""
        },
      ];
    }
  }
};
